export default __webpack_public_path__ + "static/media/sponsor-lord.ed52b29f.png";